// React
import React from 'react';

// Components
import Wrapper from '../../listing/Wrapper/Wrapper';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Hooks
import useListing from '../../../hooks/useListing';

// Data types
import {
  vistaOrderCore,
  vistaOrderListing
} from '../../../data-types/vistaOrder';

// This component
export default function VistaOrder() {
  // Data types
  const { endpoint, endpointFiltersModalExport } = vistaOrderCore();
  const {
    initialSort,
    initialFilters,
    getColumns,
    getRows,
    getFilters,
    getExportFilters
  } = vistaOrderListing();

  // Listing
  const {
    activeFilters,
    saveActiveFilters,
    page,
    pageSize,
    setPage,
    setPageSize,
    sortModel,
    setSortModel,
    resetSortModel,
    refreshDataGrid,
    setRefreshDataGrid,
    activeExportFilters,
    saveActiveExportFilters,
  } = useListing(initialSort, initialFilters, endpoint);

  // JSX
  return (
    <ListingContext.Provider
      value={{
        typeOfData: 'data-type',
        // Static
        initialFilters,
        endpoint,
        endpointFiltersModalExport,
        getColumns,
        getRows,
        getFilters,
        getExportFilters,
        // Dynamic
        activeFilters,
        saveActiveFilters,
        activeExportFilters,
        saveActiveExportFilters,
        page,
        pageSize,
        setPage,
        setPageSize,
        sortModel,
        setSortModel,
        resetSortModel,
        refreshDataGrid,
        setRefreshDataGrid
      }}>
      <Wrapper
        title="Vista Orders"
        exportAction={true}
        exportType="filters-modal"
        buttonExportLabel="Export Data"
      />
    </ListingContext.Provider>
  );
}
